import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { Utils } from "../../../../../shared/utils/Utils";
import {
  ObjetivosPlanService,
  ObjetivosPlan,
  ObjetivosPlanPayload,
} from "../../../../../shared/services/objetivos-plan.service";
import {
  MetasPlan,
  MetasPlanPayload,
  MetasPlanService,
} from "../../../../../shared/services/metas-plan.service";
import {
  ResponsabilidadPlan,
  ResponsabilidadPlanPayload,
  ResponsabilidadPlanService,
} from "../../../../../shared/services/responsabilidad-plan.service";
import { CargosService } from "../../../../../shared/services/cargos.service";
import {
  IndicadoresPlan,
  IndicadoresPlanPayload,
  IndicadoresPlanService,
} from "../../../../../shared/services/indicadores-plan.service";
import { catchError, Observable, of } from "rxjs";
import {
  ResponsabilidadDesPlan,
  ResponsabilidadDesPlanPayload,
  ResponsabilidadDesPlanService,
} from "../../../../../shared/services/responsabilidad-des-plan.service";

interface CatalogoCargaConfig {
  getFn: () => Observable<any>;
  asignarA: (lista: CatalogoItem[]) => void;
}

interface CatalogoItem {
  id: number;
  descripcion: string;
  [key: string]: any;
}

interface CatalogoCrearConfig {
  descripcion: string;
  modal: any;
  createFn: (payload: {
    descripcion: string;
    estado: number;
  }) => Observable<any>;
  reloadFn: () => void;
  entidadNombre: string;
}

@Component({
  selector: "app-gestion-general",
  templateUrl: "./gestion-general.component.html",
  styleUrls: ["./gestion-general.component.scss"],
})
export class GestionGeneralComponent implements OnInit {
  GestionId!: number;
  cargandoLista = false;
  objetivosForm!: FormGroup;
  guardando = false;
  listaObjetivos: ObjetivosPlan[] = [];
  filtroTexto = "";
  objetivoEditando: ObjetivosPlan | null = null;
  editarForm!: FormGroup;
  guardandoEdicion = false;
  cargandoObjetivo = false;
  page = 1;
  pageSize = 5;
  listaResponsabilidades: ResponsabilidadPlan[] = [];
  responsabilidadForm!: FormGroup;
  responsabilidadEditando: ResponsabilidadPlan | null = null;
  guardandoResponsabilidad = false;
  filtroTextoResponsabilidades = "";
  pageResponsabilidades = 1;
  pageSizeResponsabilidades = 5;
  cargosDisponibles: any[] = [];
  guardandoIndicador = false;
  editarIndicadorForm!: FormGroup;
  guardandoEdicionIndicador = false;
  cargandoIndicador = false;
  activeTab = 1;

  tiposCalculo = [
    { id: "CUMPLIMIENTO", nombre: "Cumplimiento" },
    { id: "COBERTURA", nombre: "Cobertura" },
    { id: "TASA", nombre: "Tasa" },
    { id: "INDICE", nombre: "Índice" },
  ];

  periodicidades = ["Mensual", "Bimestral", "Trimestral", "Semestral", "Anual"];
  responsabilidadDesForm!: FormGroup;
listaResponsabilidadesDes: ResponsabilidadDesPlan[] = [];
guardandoResponsabilidadDes = false;
cargandoResponsabilidadDes = false;
idsResponsabilidadDesEliminadas: number[] = [];
  

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private objetivosPlanService: ObjetivosPlanService,
    private responsabilidadPlanService: ResponsabilidadPlanService,
    private cargosService: CargosService,
    private responsabilidadDesPlanService: ResponsabilidadDesPlanService,
  ) {}

  ngOnInit(): void {
    this.GestionId = Number(this.route.snapshot.paramMap.get("id"));

    this.inicializarFormCreacion();
    this.inicializarFormEdicion();
    this.inicializarFormResponsabilidad();
    this.inicializarFormResponsabilidadDes();
    this.cargarObjetivos();
    this.cargarResponsabilidades();
    this.cargarCargos();
  }

  inicializarFormCreacion(): void {
    this.objetivosForm = this.fb.group({
      objetivos: this.fb.array([this.crearItemObjetivo()]),
    });
  }

  crearItemObjetivo(valor: string = ""): FormGroup {
    return this.fb.group({
      objetivos: [valor, [Validators.required, Validators.maxLength(2000)]],
    });
  }

  get objetivosArray(): FormArray {
    return this.objetivosForm.get("objetivos") as FormArray;
  }

  agregarFila(): void {
    this.objetivosArray.push(this.crearItemObjetivo());
  }

  eliminarFila(index: number): void {
    if (this.objetivosArray.length === 1) {
      this.objetivosArray.at(0).reset();
      return;
    }
    this.objetivosArray.removeAt(index);
  }

  guardarTodos(modal?: any): void {
    if (this.objetivosForm.invalid) {
      this.objetivosArray.controls.forEach((c) => c.get("objetivos")?.markAsTouched());
      Swal.fire({ icon: "warning", title: "Campos incompletos", text: "Por favor complete todos los objetivos antes de guardar." });
      return;
    }

    if (!this.GestionId) {
      Swal.fire({ icon: "error", title: "Falta el plan", text: "No se encontró el ID del plan en la ruta." });
      return;
    }

    const payloads: ObjetivosPlanPayload[] = this.objetivosArray.value
      .map((item: any) => ({
        id_plan: this.GestionId,
        objetivos: (item.objetivos || "").trim(),
        estado: 1,
      }))
      .filter((p: ObjetivosPlanPayload) => p.objetivos.length > 0);

    if (payloads.length === 0) {
      Swal.fire({ icon: "warning", title: "Nada para guardar", text: "Ingrese al menos un objetivo válido." });
      return;
    }

    this.guardando = true;
    const peticiones = payloads.map((p) => this.objetivosPlanService.create(p));

    Promise.allSettled(peticiones.map((obs) => obs.toPromise()))
      .then((resultados) => {
        const exitosos = resultados.filter((r) => r.status === "fulfilled").length;
        const fallidos = resultados.filter((r) => r.status === "rejected").length;

        this.guardando = false;
        this.inicializarFormCreacion();
        this.cargarObjetivos();
        if (modal) modal.close();

        if (fallidos === 0) {
          Swal.fire({ icon: "success", title: "Objetivos guardados", text: `Se guardaron ${exitosos} objetivo(s) correctamente.`, timer: 2000, showConfirmButton: false });
        } else {
          Swal.fire({ icon: "warning", title: "Guardado parcial", text: `${exitosos} guardados, ${fallidos} fallaron. Verifique e intente de nuevo.` });
        }
      })
      .catch(() => {
        this.guardando = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar los objetivos." });
      });
  }

  cargarObjetivos(): void {
    this.cargandoLista = true;
    this.objetivosPlanService.getByIdPlan(this.GestionId).subscribe({
      next: (data) => { this.listaObjetivos = data; this.cargandoLista = false; },
      error: () => { this.cargandoLista = false; },
    });
  }

  get objetivosFiltrados(): ObjetivosPlan[] {
    if (!this.filtroTexto.trim()) return this.listaObjetivos;
    const texto = this.filtroTexto.toLowerCase();
    return this.listaObjetivos.filter((o) => o.objetivos.toLowerCase().includes(texto));
  }

  inicializarFormEdicion(): void {
    this.editarForm = this.fb.group({
      objetivos: ["", [Validators.required, Validators.maxLength(2000)]],
    });
  }

  abrirModalObjetivo(modalRef: any, objetivo?: ObjetivosPlan): void {
    if (objetivo) {
      if (!objetivo.id) return;

      this.cargandoObjetivo = true;
      this.objetivoEditando = null;
      this.editarForm.reset();

      const modalInstancia = this.modalService.open(modalRef, { size: "lg", backdrop: "static" });

      this.objetivosPlanService.getById(objetivo.id).subscribe({
        next: (data) => {
          this.objetivoEditando = data;
          this.editarForm.patchValue({ objetivos: data.objetivos });
          this.cargandoObjetivo = false;
        },
        error: () => {
          this.cargandoObjetivo = false;
          modalInstancia.dismiss();
          Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar el objetivo seleccionado." });
        },
      });
    } else {
      this.objetivoEditando = null;
      this.inicializarFormCreacion();
      this.modalService.open(modalRef, { size: "lg", backdrop: "static" });
    }
  }

  guardarEdicion(modal: any): void {
    if (this.editarForm.invalid || !this.objetivoEditando?.id) {
      this.editarForm.markAllAsTouched();
      return;
    }

    this.guardandoEdicion = true;
    this.objetivosPlanService.update(this.objetivoEditando.id, { objetivos: this.editarForm.value.objetivos.trim() }).subscribe({
      next: () => {
        this.guardandoEdicion = false;
        modal.close();
        this.cargarObjetivos();
        Swal.fire({ icon: "success", title: "Actualizado", timer: 1500, showConfirmButton: false });
      },
      error: () => {
        this.guardandoEdicion = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar el objetivo." });
      },
    });
  }

  cambiarEstado(objetivo: ObjetivosPlan): void {
    if (!objetivo.id) return;
    const accion = objetivo.estado === 1 ? "inactivar" : "activar";

    Swal.fire({
      icon: "question",
      title: `¿${accion === "inactivar" ? "Inactivar" : "Activar"} objetivo?`,
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const peticion = accion === "inactivar" ? this.objetivosPlanService.inactivar(objetivo.id!) : this.objetivosPlanService.activar(objetivo.id!);

      peticion.subscribe({
        next: () => {
          this.cargarObjetivos();
          Swal.fire({ icon: "success", title: "Estado actualizado", timer: 1200, showConfirmButton: false });
        },
        error: () => Swal.fire({ icon: "error", title: "Error", text: "No se pudo cambiar el estado." }),
      });
    });
  }


  inicializarFormResponsabilidad(): void {
  this.responsabilidadForm = this.fb.group({
    id_cargo: [null, [Validators.required]],
  });
}

  cargarResponsabilidades(): void {
    this.cargandoLista = true;
    this.responsabilidadPlanService.getByIdPlan(this.GestionId).subscribe({
      next: (data) => { this.listaResponsabilidades = data; this.cargandoLista = false; },
      error: () => { this.cargandoLista = false; },
    });
  }

  cargarCargos(): void {
    this.cargosService.getCargosActivos().subscribe({
      next: (data) => { this.cargosDisponibles = data; },
    });
  }

  get responsabilidadesFiltradas(): ResponsabilidadPlan[] {
    if (!this.filtroTextoResponsabilidades.trim()) return this.listaResponsabilidades;
    const texto = this.filtroTextoResponsabilidades.toLowerCase();
    return this.listaResponsabilidades.filter(
      (r) =>
        (r.CargosData?.cargos || "").toLowerCase().includes(texto)
    );
  }

  abrirModalResponsabilidad(modalRef: any, responsabilidad?: ResponsabilidadPlan): void {
    this.responsabilidadEditando = responsabilidad || null;
    this.responsabilidadForm.reset();
    this.inicializarFormResponsabilidadDes(); // arranca limpio con una fila vacía
    this.idsResponsabilidadDesEliminadas = [];

    if (responsabilidad?.id) {
      // ===== MODO EDICIÓN: trae el cargo + sus descripciones asociadas =====
      this.responsabilidadForm.patchValue({ id_cargo: responsabilidad.id_cargo });

      this.cargandoResponsabilidadDes = true;
      const modalInstancia = this.modalService.open(modalRef, { size: "lg", backdrop: "static" });

      this.responsabilidadDesPlanService.getByIdResponsabilidad(responsabilidad.id).subscribe({
        next: (data) => {
          this.listaResponsabilidadesDes = data;

          // Reconstruye el FormArray con las descripciones existentes
          const array = this.responsabilidadDesArray;
          array.clear();

          if (data.length > 0) {
            data.forEach((d) => array.push(this.crearItemResponsabilidadDes(d.id, d.descripcion)));
          } else {
            array.push(this.crearItemResponsabilidadDes());
          }

          this.cargandoResponsabilidadDes = false;
        },
        error: () => {
          this.cargandoResponsabilidadDes = false;
          modalInstancia.dismiss();
          Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar las descripciones de responsabilidad." });
        },
      });
    } else {
      // ===== MODO CREACIÓN: cargo nuevo + descripciones nuevas =====
      this.modalService.open(modalRef, { size: "lg", backdrop: "static" });
    }
  }

  guardarResponsabilidad(modal: any): void {
    if (this.responsabilidadForm.invalid || this.responsabilidadDesForm.invalid) {
      this.responsabilidadForm.markAllAsTouched();
      this.responsabilidadDesArray.controls.forEach((c) => c.get("descripcion")?.markAsTouched());
      Swal.fire({ icon: "warning", title: "Campos incompletos", text: "Complete el cargo y al menos una responsabilidad válida." });
      return;
    }

    if (!this.GestionId) {
      Swal.fire({ icon: "error", title: "Falta el plan", text: "No se encontró el ID del plan en la ruta." });
      return;
    }

    this.guardandoResponsabilidad = true;
    const valores = this.responsabilidadForm.value;

    if (this.responsabilidadEditando?.id) {
      // ===== EDICIÓN: actualiza el cargo, luego sincroniza las descripciones =====
      this.responsabilidadPlanService.update(this.responsabilidadEditando.id, { id_cargo: valores.id_cargo }).subscribe({
        next: () => {
          this.guardarDescripcionesResponsabilidad(this.responsabilidadEditando!.id!, modal);
        },
       error: (error) => {
  this.guardandoResponsabilidad = false;
  Swal.fire({
    icon: "error",
    title: "Error",
    text: this.obtenerMensajeError(error, "No se pudo actualizar el cargo."),
  });
},
      });
    } else {
      // ===== CREACIÓN: crea el cargo primero para obtener su ID =====
      const payload: ResponsabilidadPlanPayload = {
        id_plan: this.GestionId,
        id_cargo: valores.id_cargo,
        estado: 1,
      };

      this.responsabilidadPlanService.create(payload).subscribe({
        next: (respuesta: any) => {
          const nuevoId = respuesta?.data?.id || respuesta?.id;
          if (!nuevoId) {
            this.guardandoResponsabilidad = false;
            Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener el ID del cargo creado." });
            return;
          }
          this.guardarDescripcionesResponsabilidad(nuevoId, modal);
        },
        error: (error) => {
  this.guardandoResponsabilidad = false;
  Swal.fire({
    icon: "error",
    title: "Error",
    text: this.obtenerMensajeError(error, "No se pudo crear el cargo."),
  });
},
      });
    }
  }

private guardarDescripcionesResponsabilidad(id_responsabilidad: number, modal: any): void {
  const items = this.responsabilidadDesArray.value.filter((item: any) => (item.descripcion || "").trim().length > 0);

  const peticiones = items.map((item: any) => {
    const descripcion = item.descripcion.trim();

    if (item.id) {
      return this.responsabilidadDesPlanService.update(item.id, { descripcion }).toPromise();
    } else {
      const payload: ResponsabilidadDesPlanPayload = {
        id_responsabilidad,
        descripcion,
        estado: 1,
      };
      return this.responsabilidadDesPlanService.create(payload).toPromise();
    }
  });

  // 🔹 Inactivar en backend las que el usuario quitó del formulario
  const peticionesInactivar = this.idsResponsabilidadDesEliminadas.map((id) =>
    this.responsabilidadDesPlanService.inactivar(id).toPromise(),
  );

  Promise.allSettled([...peticiones, ...peticionesInactivar])
    .then((resultados) => {
      const exitosos = resultados.filter((r) => r.status === "fulfilled").length;
      const fallidos = resultados.filter((r) => r.status === "rejected").length;

      this.guardandoResponsabilidad = false;
      this.idsResponsabilidadDesEliminadas = []; // limpia el tracker
      modal.close();
      this.cargarResponsabilidades();

      if (fallidos === 0) {
        Swal.fire({
          icon: "success",
          title: this.responsabilidadEditando ? "Responsabilidad actualizada" : "Responsabilidad guardada",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Guardado parcial",
          text: `${exitosos} guardadas, ${fallidos} fallaron.`,
        });
      }
    })
    .catch(() => {
      this.guardandoResponsabilidad = false;
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar las descripciones de responsabilidad." });
    });
}

  cambiarEstadoResponsabilidad(responsabilidad: ResponsabilidadPlan): void {
    if (!responsabilidad.id) return;
    const accion = responsabilidad.estado === 1 ? "inactivar" : "activar";

    Swal.fire({
      icon: "question",
      title: `¿${accion === "inactivar" ? "Inactivar" : "Activar"} responsabilidad?`,
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const peticion = accion === "inactivar" ? this.responsabilidadPlanService.inactivar(responsabilidad.id!) : this.responsabilidadPlanService.activar(responsabilidad.id!);

      peticion.subscribe({
        next: () => {
          this.cargarResponsabilidades();
          Swal.fire({ icon: "success", title: "Estado actualizado", timer: 1200, showConfirmButton: false });
        },
        error: () => Swal.fire({ icon: "error", title: "Error", text: "No se pudo cambiar el estado." }),
      });
    });
  }


  obtenerNombreTipoCalculo(id: string): string {
    return this.tiposCalculo.find((t) => t.id === id)?.nombre || id;
  }


  exportarExcel(tablaId: string, nombreArchivo: string): void {
    Utils.exportVisibleTableToExcel(tablaId, nombreArchivo);
  }

  exportToPDF(tablaId: string, nombreArchivo: string, titulo: string): void {
    Utils.exportToPDF(tablaId, nombreArchivo, titulo);
  }

  private normalizarLista(response: any): CatalogoItem[] {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    return [];
  }

  private recargarCatalogo(config: CatalogoCargaConfig): void {
      config
        .getFn()
        .pipe(catchError(() => of([])))
        .subscribe((response: any) => {
          config.asignarA(this.normalizarLista(response));
        });
  }

  private crearItemCatalogo(config: CatalogoCrearConfig): void {
      const descripcion = config.descripcion?.trim();
  
      if (!descripcion) {
        Swal.fire("Error", "La descripción no puede estar vacía.", "error");
        return;
      }
  
      const payload = { descripcion: descripcion.toUpperCase(), estado: 1 };
  
      config.createFn(payload).subscribe({
        next: (response: any) => {
          const nuevoId = response?.data?.id || response?.id;
          config.modal.close();
          Swal.fire(
            "Éxito",
            `${config.entidadNombre} creado correctamente.`,
            "success",
          );
          config.reloadFn();
        },
        error: (error: any) => {
          const mensaje =
            error?.error?.error || `No se pudo crear: ${config.entidadNombre}.`;
          Swal.fire("Error", mensaje, "error");
        },
      });
  }
  

  abrirModal(modalRef: any, size: "lg" | "xl" = "lg"): void {
    this.modalService.open(modalRef, { centered: true, size });
  }

  inicializarFormResponsabilidadDes(): void {
    this.responsabilidadDesForm = this.fb.group({
      descripciones: this.fb.array([this.crearItemResponsabilidadDes()]),
    });
  }

  crearItemResponsabilidadDes(id?: number, descripcion: string = ""): FormGroup {
    return this.fb.group({
      id: [id || null],
      descripcion: [descripcion, [Validators.required, Validators.maxLength(500)]],
    });
  }

  get responsabilidadDesArray(): FormArray {
    return this.responsabilidadDesForm.get("descripciones") as FormArray;
  }

  agregarFilaResponsabilidadDes(): void {
    this.responsabilidadDesArray.push(this.crearItemResponsabilidadDes());
  }

eliminarFilaResponsabilidadDes(index: number): void {
  const item = this.responsabilidadDesArray.at(index);
  const idExistente = item.get("id")?.value;

  if (this.responsabilidadDesArray.length === 1) {
    this.responsabilidadDesArray.at(0).reset({ id: null, descripcion: "" });
    if (idExistente) this.idsResponsabilidadDesEliminadas.push(idExistente);
    return;
  }

  if (idExistente) {
    this.idsResponsabilidadDesEliminadas.push(idExistente);
  }
  this.responsabilidadDesArray.removeAt(index);
}

  private obtenerMensajeError(error: any, defecto: string): string {
  return (
    error?.error?.error ||
    error?.error?.message ||
    error?.message ||
    defecto
  );
}
}